import { api } from './api';
import type { TrackedCompetitor, CompetitorDetailResponse } from '@traaker/shared';

/**
 * Tracked-competitor CRUD (Competitors feature). The relationship rows are the
 * source of truth; the backend keeps `brand.competitors` in sync.
 */
export const competitorsApi = {
  list: (brandId: string): Promise<TrackedCompetitor[]> =>
    api.get<TrackedCompetitor[]>(`/brands/${brandId}/competitors`),

  add: (brandId: string, body: { name: string; domain?: string; pinned?: boolean }) =>
    api.post<TrackedCompetitor>(`/brands/${brandId}/competitors`, body),

  remove: (brandId: string, domain: string) =>
    api.delete(`/brands/${brandId}/competitors/${encodeURIComponent(domain)}`),

  detail: (brandId: string, domain: string): Promise<CompetitorDetailResponse> =>
    api.get<CompetitorDetailResponse>(
      `/brands/${brandId}/competitors/${encodeURIComponent(domain)}/detail`,
    ),

  /** Resolve a suggested competitor's real domain from its name (Serper-backed). */
  resolveDomain: (brandId: string, name: string): Promise<{ name: string; domain: string | null }> =>
    api.get<{ name: string; domain: string | null }>(
      `/brands/${brandId}/competitors/resolve/domain?name=${encodeURIComponent(name)}`,
    ),
};
